import type { TrafficSourceItem, TrafficSourcesServer } from '@metapic-apps/shared'

export const normalizeTrafficSources = (sources: TrafficSourcesServer[]): TrafficSourceItem[] =>
  sources.map((item) => ({ source: item.source, name: item.name }))
